import { Injectable } from '@angular/core';
import { InsightsRestService } from '../service/insights-rest-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeatureCollection } from '../models';
import { map } from 'rxjs/operators';
import { SearchIntersectingShapeRequest } from './search-intersecting-shape-request';

@Injectable({
  providedIn: 'root'
})
export class ShapeService extends InsightsRestService {

  private readonly path = '/shape';

  constructor(protected http: HttpClient) {
    super();
  }

  searchIntersectingShape(request: SearchIntersectingShapeRequest): Observable<FeatureCollection> {
    const url = this.buildUrl(`${this.path}/search`);

    return this.http.post(url, request)
      .pipe(map((result: any) => new FeatureCollection(result)));
  }
}
